export default __webpack_public_path__ + "static/media/Brow_1_C5.5c85385c.svg";